<template>
  <v-sheet max-width="700px" class="mx-auto">
    <v-container fluid>
      <v-row>
        <v-col class="text-h5 font-weight-bold"> SAGC Songbook </v-col>
      </v-row>
      <v-row class="mt-n2">
        <v-col>
          <v-text-field
            @keydown.enter="search"
            placeholder="Search by title, lyrics or song number"
            clearable
            v-model="searchText"
            variant="outlined"
            hide-details
          ></v-text-field>
          <v-autocomplete
            class="mt-3"
            v-model="selectedThemes"
            :items="themes"
            label="Suggest by theme"
            placeholder="Select one or more themes"
            multiple
            chips
            closable-chips
            clearable
            variant="outlined"
            hide-details
            @update:model-value="search"
          ></v-autocomplete>
          <p v-if="selectedThemes.length && !titleSortActive" class="text-caption text-medium-emphasis mt-2 mb-0">
            Songs that fit more of the selected themes are listed first.
          </p>
          <p class="d-flex justify-center mt-3">
            <v-btn color="success" @click="search">Search</v-btn> &nbsp;
            <v-btn @click="reset" variant="text">Reset</v-btn>
          </p>
        </v-col>
      </v-row>

      <v-row v-if="hasResults" class="mt-10">
        <v-col class="d-flex justify-center align-center">
          <v-btn-toggle v-model="selectedSongBook" group density="compact">
            <v-btn v-for="sb in songBooks" :key="sb" :value="sb">
              {{ sb }} {{ filteredSongCount(sb) }}
            </v-btn>
          </v-btn-toggle>
          <v-btn
            class="ml-2"
            density="compact"
            :color="titleSortActive ? 'primary' : undefined"
            :variant="titleSortActive ? 'flat' : 'outlined'"
            @click="cycleTitleSort"
          >
            {{ titleSort === "desc" ? "Z–A" : "A–Z" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!hasResults && searchAttempted">
        <v-col class="text-center text-medium-emphasis">No songs match this search.</v-col>
      </v-row>
      <v-row density="compact" v-if="hasResults">
        <v-col density="compact">
          <v-data-table
            :headers="headers"
            :items="filtered[selectedSongBook]"
            hide-actions
            item-key="title"
            :loading="searching"
            items-per-page="50"
            class="mt-1"
            density="compact"
          >
            <template v-slot:[`item.title`]="{ item }">
              <div>{{ songOf(item).title }}</div>
              <div class="text-caption text-medium-emphasis">
                <span v-for="(theme, index) in visibleThemes(songOf(item))" :key="theme">
                  <span :class="selectedThemes.includes(theme) ? 'text-primary font-weight-bold' : ''">{{ theme }}</span><span v-if="index < visibleThemes(songOf(item)).length - 1"> · </span>
                </span>
                <span v-if="hiddenThemeCount(songOf(item))"> ... +{{ hiddenThemeCount(songOf(item)) }} other theme{{ hiddenThemeCount(songOf(item)) === 1 ? '' : 's' }}</span>
              </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn size="small" elevation="0" variant="tonal" @click="songClicked(songOf(item))"
                >View</v-btn
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-dialog v-model="showLyrics" max-height="90%" max-width="600px">
      <v-sheet v-if="showLyrics">
        <LyricsDialog :currentSong="currentSong" @close="showLyrics=false"></LyricsDialog>
      
      </v-sheet>
      </v-dialog>
      
      <v-snackbar v-model="snackbarVisible">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarVisible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>      
    </v-container>
  </v-sheet>
</template>

<script>
import { isUndefined } from "lodash";
import LyricsDialog from "../components/LyricsDialog.vue";
const _ = require("lodash");

export default {
  components: {
    LyricsDialog,
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = to.params
    var songbook = params.songbook
    var id = params.id
    this.showSongItem(songbook,id)
    next()
  },  
  mounted: function () {
    var self = this;
    this.getSongs().then((result) => {
      self.songs = result.songs;
      self.themes = result.themes || [];
      self.reset();
    });
  },
  computed: {
    titleSortActive: function () {
      return this.titleSort === "asc" || this.titleSort === "desc";
    },
    hasResults: function () {
      var total = 0;
      _.map(this.filtered, (o) => {
        total = total + o.length;
      });
      return total > 0;
    },
    clipboardText: function () {
      return [this.currentSong.title, this.currentSong.lyrics].join("\n\n");
    },
  },
  data: function () {
    return {
      songs: [],
      themes: [],
      filtered: {},
      searcher: null,
      searchText: "",
      selectedThemes: [],
      searchAttempted: false,
      searching: false,
      searchingOptions: {},
      showLyrics: false,
      currentSong: {},
      songBooks: [],
      maxSearch: 50,
      tab: "1",
      selectedSongBook: "",
      titleSort: null,
      headers: [
        { text: "Title", value: "title" },
        { text: "Action", value: "action", width: "50px" },
      ],
      snackbarVisible:false,
      snackbarText:''
    };
  },

  methods: {
    showSongItem: function(songbook,id){
      var songBook = this.songBooks[songbook]
      var song = _.find(songBook, {id:id})
      this.currentSong=song
      this.showLyrics=true
    },

    songOf: function (item) {
      if (item && item.raw) return item.raw;
      return item || {};
    },

    visibleThemes: function (song) {
      var themes = (song && song.themes) || [];
      var selected = this.selectedThemes || [];
      if (selected.length) {
        return selected.filter(function (theme) {
          return themes.indexOf(theme) >= 0;
        });
      }
      return themes.slice(0, 2);
    },

    hiddenThemeCount: function (song) {
      var themes = (song && song.themes) || [];
      return Math.max(0, themes.length - this.visibleThemes(song).length);
    },

    songClicked: function (data) {
      this.currentSong = data;
      this.showLyrics = true;
    },

    message: function(message){
      this.snackbarText=message
      this.snackbarVisible=true
    },


    cycleTitleSort: function () {
      if (this.titleSort === "asc") this.titleSort = "desc";
      else if (this.titleSort === "desc") this.titleSort = null;
      else this.titleSort = "asc";
      this.search();
    },

    filteredSongCount: function (sb) {
      if (isUndefined(this.filtered[sb])) {
        return "";
      }
      return "(" + this.filtered[sb].length + ")";
    },

    reset: function () {
      var self = this;
      var filtered = {};
      this.songBooks = _.uniq(_.map(this.songs, "songbook")).reverse();

      _.map(this.songBooks, (sb) => {
        filtered[sb] = _.sortBy(_.filter(self.songs, { songbook: sb }), (o) =>
          o.title_text.toLowerCase()
        );
      });

      this.selectedSongBook = this.songBooks[0];
      this.filtered = filtered;
      this.searchText = "";
      this.selectedThemes = [];
      this.titleSort = null;
      this.searchAttempted = false;
    },

    search: function () {
      var self = this;
      var themes = this.selectedThemes || [];
      var searchText = (this.searchText || "").toLowerCase().replace(/[^a-z0-9]/gi, "");
      var textActive = searchText.length >= 3;

      if (!textActive && themes.length === 0) {
        if ((this.searchText || "").trim().length > 0) {
          this.searchAttempted = true;
          this.applySongLists([], true);
          return;
        }
        this.searchAttempted = false;
        this.applySongLists(
          this.applyTitleSort(_.sortBy(this.songs, (song) => song.title_text.toLowerCase())),
          false
        );
        return;
      }

      this.searching = true;
      this.searchAttempted = true;
      var ordered = this.songs;

      if (textActive) {
        var titleMatches = _.filter(self.songs, (song) => {
          return song.title.toLowerCase().indexOf(searchText) >= 0;
        });
        var bodyMatches = _.filter(self.songs, (song) => {
          return song.search.indexOf(searchText) >= 0;
        });
        ordered = _.uniqBy(titleMatches.concat(bodyMatches), "title");
      }

      if (themes.length > 0) {
        ordered = _.filter(ordered, (song) => {
          return themes.some((theme) => (song.themes || []).indexOf(theme) >= 0);
        });
        ordered = _.sortBy(ordered, [
          (song) => -self.themeMatchCount(song, themes),
          (song) => song.title_text.toLowerCase(),
        ]);
      }

      this.applySongLists(this.applyTitleSort(ordered), true);
      this.searching = false;
    },

    applyTitleSort: function (songs) {
      if (this.titleSort !== "asc" && this.titleSort !== "desc") return songs;
      var direction = this.titleSort === "desc" ? -1 : 1;
      return songs.slice().sort(function (a, b) {
        return direction * (a.title_text || "").localeCompare(b.title_text || "", undefined, { sensitivity: "base" });
      });
    },

    themeMatchCount: function (song, themes) {
      return themes.filter((theme) => (song.themes || []).indexOf(theme) >= 0).length;
    },

    applySongLists: function (ordered, preferMatches) {
      var filtered = {};
      var self = this;
      if (!this.songBooks.length) {
        this.songBooks = _.uniq(_.map(this.songs, "songbook")).reverse();
      }
      _.map(this.songBooks, (sb) => {
        filtered[sb] = _.filter(ordered, { songbook: sb });
      });
      this.filtered = filtered;
      if (preferMatches) this.selectActiveSongbook();
      else this.selectedSongBook = this.songBooks[0];
      return self;
    },

    selectActiveSongbook(){
      for (var i = 0; i < this.songBooks.length; i++) {
        var sb = this.songBooks[i];
        if (this.filtered[sb] && this.filtered[sb].length > 0) {
          this.selectedSongBook = sb;
          return;
        }
      }
    },

    getSongs: async function () {
      var response = await fetch(`/songs.json`);
      return await response.json();
    },
  },
};

</script>
